"use client"

import { Card } from "antd"

export default function SplitTemplate({ cart: cartProp }) {
  const cart = cartProp || { items: [], total: 0, paid: 0, salesRepName: "" };

  // Calculate totalItems and total from cart.items
  const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
  const total = cart.items.reduce((sum, item) => {
    const price = item.price || 0;
    const quantity = item.quantity || 1;
    return sum + (price * quantity);
  }, 0);

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(to right, #EFF6FF, #F3E8FF)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "row",
          minHeight: 0,
        }}
        className="lg:grid-cols-2"
      >
        {/* Left Side - Promotions */}
        <div
          style={{
            background: "linear-gradient(to bottom right, #2563EB, #7E22CE)",
            padding: 32,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: "#FFFFFF",
            fontSize: "1vw",
            width: "50%",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <h1
              style={{
                fontSize: "3em",
                fontWeight: "bold",
              }}
            >
              Special Offers
            </h1>
            <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
              <div
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(4px)",
                }}
              >
                <div style={{ fontSize: "1vw", marginBottom: 5 }}>🎉</div>
                <h3
                  style={{
                    fontSize: "3em",
                    fontWeight: "bold",
                    marginBottom: 5,
                  }}
                >
                  Happy Hour
                </h3>
                <p style={{ fontSize: "1em", opacity: 0.9 }}>
                  Buy 2 Get 1 Free on all beverages
                </p>
                <div
                  style={{
                    marginTop: 10,
                    color: "#FDE047",
                    fontWeight: "bold",
                  }}
                >
                  Until 6 PM
                </div>
              </div>

              <div
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: 16,
                  padding: 24,
                  backdropFilter: "blur(4px)",
                }}
              >
                <div style={{ fontSize: "1vw", marginBottom: 5 }}>🥐</div>
                <h3
                  style={{
                    fontSize: "3em",
                    fontWeight: "bold",
                    marginBottom: 5,
                  }}
                >
                  Combo Deal
                </h3>
                <p style={{ fontSize: "1em", opacity: 0.9 }}>
                  Coffee + Pastry for just $5.99
                </p>
                <div
                  style={{
                    marginTop: 10,
                    color: "#FDE047",
                    fontWeight: "bold",
                  }}
                >
                  Save $2.00
                </div>
              </div>

              <div
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: 16,
                  padding: 24,
                  backdropFilter: "blur(4px)",
                }}
              >
                <div style={{ fontSize: "1vw", marginBottom: 5 }}>⭐</div>
                <h3
                  style={{
                    fontSize: "3em",
                    fontWeight: "bold",
                    marginBottom: 5,
                  }}
                >
                  Loyalty Program
                </h3>
                <p style={{ fontSize: 18, opacity: 0.9 }}>
                  Earn points with every purchase
                </p>
                <div
                  style={{
                    marginTop: 10,
                    color: "#FDE047",
                    fontWeight: "bold",
                  }}
                >
                  Join Today
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Order */}
        <div
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "column",
            width: "50vw",
            //minHeight: 0,
          }}
        >
          <div style={{ textAlign: "center", flexShrink: 0, fontSize:"1vw" }}>
            <h2
              style={{
                fontSize: "3em",
                fontWeight: "bold",
                color: "#1F2937",
              }}
            >
              Your Order
            </h2>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#10B981",
                  borderRadius: "50%",
                  animation: "pulse 2s infinite",
                }}
              ></div>
              <span style={{ color: "#4B5563" }}>Real-time updates</span>
            </div>
          </div>

          <Card
            title={
              <div
                style={{
                  background: "linear-gradient(to right, #1F2937, #374151)",
                  color: "#FFFFFF",
                  padding: "16px 0",
                  textAlign: "center",
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                Order Details
              </div>
            }
            style={{
              flex: 1,
              boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)",
              border: "none",
              minHeight: 0,
            }}
            styles={{ body: {
              padding: 24,
              display: "flex",
              flexDirection: "column",
              height: "100%", // Remove calc to rely on flex
            } }}
          >
            {cart.items.length === 0 ? (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 96,
                    height: 96,
                    background: "#F3F4F6",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: 40, color: "#9CA3AF" }}>🛍️</span>
                </div>
                <h3
                  style={{
                    fontSize: 20,
                    fontWeight: "600",
                    color: "#4B5563",
                    marginBottom: 8,
                  }}
                >
                  No items selected
                </h3>
                <p style={{ color: "#6B7280", textAlign: "center" }}>
                  Your order items will appear here
                </p>
              </div>
            ) : (
              <>
                {/* Scrollable Items List */}
                <div
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    paddingRight: 8,
                    minHeight: 0,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                    {cart.items.map((item) => (
                      <div
                        key={item.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 16,
                          padding: 16,
                          background: "#F9FAFB",
                          borderRadius: 8,
                          flexShrink: 0, // Prevent items from shrinking
                        }}
                      >
                        <img
                          src={item.image}
                          alt={item.name}
                          style={{
                            width: 64,
                            height: 64,
                            objectFit: "cover",
                            borderRadius: 8,
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          onError={(e) => (e.target.src = "/placeholder.svg?height=60&width=60")}
                        />
                        <div style={{ flex: 1 }}>
                          <h4
                            style={{
                              fontSize: 18,
                              fontWeight: "600",
                              color: "#1F2937",
                            }}
                          >
                            {item.name}
                          </h4>
                          <p style={{ color: "#4B5563" }}>
                            ${(item.price || 0).toFixed(2)} × {item.quantity || 1}
                          </p>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "#2563EB",
                            }}
                          >
                            ${((item.price || 0) * (item.quantity || 1)).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Fixed Total Section */}
                <div
                  style={{
                    borderTop: "2px solid #E5E7EB",
                    paddingTop: 24,
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: 18, color: "#4B5563" }}>
                      Items: {totalItems}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 24,
                        fontWeight: "bold",
                        color: "#1F2937",
                      }}
                    >
                      Total:
                    </span>
                    <span
                      style={{
                        fontSize: 30,
                        fontWeight: "bold",
                        color: "#2563EB",
                      }}
                    >
                      ${isNaN(total) ? "0.00" : total.toFixed(2)}
                    </span>
                  </div>
                </div>
              </>
            )}
          </Card>

          <div style={{ marginTop: 24, textAlign: "center", flexShrink: 0 }}>
            <div
              style={{
                background: "linear-gradient(to right, #22C55E, #059669)",
                color: "#FFFFFF",
                borderRadius: 8,
                padding: 16,
              }}
            >
              <div style={{ fontSize: 24, marginBottom: 8 }}>🙏</div>
              <div style={{ fontWeight: "600" }}>
                Thank you for your order!
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Animations and Scrollbar Styles */}
      <style jsx global>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.5;
            transform: scale(1.1);
          }
        }
        @media (max-width: 1024px) {
          div[style*="flex-direction: row"] {
            flex-direction: column !important;
          }
          div[style*="width: '50%'"] {
            width: 100% !important;
            height: 50%;
          }
        }
        div[style*="overflowY: 'auto'"]::-webkit-scrollbar {
          width: 8px;
        }
        div[style*="overflowY: 'auto'"]::-webkit-scrollbar-track {
          background: #f3f4f6; /* Match card background */
          borderRadius: 4px;
        }
        div[style*="overflowY: 'auto'"]::-webkit-scrollbar-thumb {
          background: #d1d5db; /* Gray-300 for thumb */
          borderRadius: 4px;
        }
        div[style*="overflowY: 'auto'"]::-webkit-scrollbar-thumb:hover {
          background: #9ca3af; /* Gray-400 on hover */
        }
      `}</style>
    </div>
  )
}